import api from "./api";

export const accessoriesService = {

  // 🧾 CREATE ACCESSORY (ADMIN)
  createAccessory: async (data) => {
    try {
      const response = await api.post("/create-accessory", data);
      return response.data;
    } catch (error) {
      throw error;
    }
},

// 📊 CATEGORY REPORT (Helmet, etc.)
getCategoryReport: async (params = {}) => {
  try {

    // 🔥 ADD HERE (IMPORTANT)
    const filteredParams = Object.fromEntries(
      Object.entries(params).filter(
        ([_, value]) =>
          value !== "" &&
          value !== null &&
          value !== undefined
      )
    );

    const query = new URLSearchParams(filteredParams).toString();

    console.log("FINAL QUERY:", query); // optional debug

    const response = await api.get(
      `/accessories-category-report${query ? `?${query}` : ""}`
    );

    return response.data;

  } catch (error) {
    throw error;
  }
},
  // 📊 TOTAL ACCESSORIES REPORT (YEAR WISE)
  getTotalAccessoriesReport: async (params = {}) => {
    try {
      const query = new URLSearchParams(params).toString();
      const response = await api.get(
        `/total-sale-accessories-report${query ? `?${query}` : ""}`
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  },


};